import React, { useState, useEffect } from 'react';
import {
  Input,
  Button,
  Flex,
  Form,
  Tag,
  Select
} from "antd";
import {
  MinusOutlined,
  QuestionCircleOutlined,
  PlusOutlined,
  UndoOutlined,
} from "@ant-design/icons";

const ApplyAllAttributeList = ({ tabActive, selectedField, setSavedattributes, setIsAction, tableData, savedattributes }) => {
  const [data, setData] = useState([]);
  const [max_size, setMax_size] = useState(0);
  const [undoErrorIndex, setUndoErrorIndex] = useState(null);
  const [savedData, setSavedData] = useState([]);
  const [attribute_element_type, setAttributeElementType] = useState(null);
  const [dropdownValues, setDrropdownValues] = useState([]);


  const nonRemovedCount = data.filter(item => !item.removed).length;
  // useEffect(() => {
  //   if (savedData && savedData.length > 0) {
  //     setSavedattributes(pre => {
  //       return { ...pre, savedData }
  //     })
  //   }

  // }, [savedData])
  useEffect(() => {


    if (savedData && savedData.length > 0) {
      setSavedattributes(pre => ({
        ...pre,
        savedData
      }));
    }
  }, [savedData]);


  useEffect(() => {

    if (tabActive?.custom_field_set && selectedField) {
      const selectedVal = tabActive.custom_field_set.find(item => item.name === selectedField.label);

      if (selectedVal && selectedVal.attribute_element_type != "dropdown") {
        const values = selectedVal.values || [];
        const size = selectedVal.max_size || 0;

        let valueData = values.map(item => {
          let isexist = savedData.filter(item1 => item1.id == item.id && item1.prod_id == item.prod_id)

          if (isexist && isexist.length > 0) {
            return {
              ...item,
              new_val: isexist[0].value,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id
            }
          }
          else {
            return {
              ...item,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id
            }
          }
        })
        setData(valueData)

        setMax_size(size);

      } else {
        const values = selectedVal.values || [];
        const size = selectedVal.max_size || 0;
        // Tag initial values
        // setData(values.map(item => ({ ...item, removed: false, source: 'initial' })));
        let valdata = selectedVal.values_data.map(item => ({
          value: item.values,
          label: item.values
        }))
        setDrropdownValues(valdata);
        let valueData = values.map(item => {

          let values_mapped = null, selected_values = []
          let isexist = savedData.filter(item1 => item1.id === item.id && item1.prod_id === item1.prod_id)

          if (isexist && isexist.length > 0) {
            return {
              ...item,
              new_val: isexist[0].value,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id,
              attribute_element_type: selectedVal.attribute_element_type, // always set
            }
          }
          else {
            let splitedValues = item.val ? item.val.split(',') : [];

            return {
              ...item,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id,
              selected_values: splitedValues,
              attribute_element_type: selectedVal.attribute_element_type, // always set
            }
          }
        })

        setData(valueData)

        setMax_size(size);
      }
    }

  }, [tabActive, selectedField]);

  const handleAddValue = (l) => {

    const value_data = JSON.parse(selectedField.value);

    if (nonRemovedCount >= max_size) return;

    const newVal = {
      val: '',
      removed: false,
      source: 'new',
      attribute_key: value_data.attribute_key,
    };

    // Set for current tab visually
    setData(prev => [...prev, {
      ...newVal,
      prod_id: tabActive.prod_id,
      store: tabActive.store,
      store_id: tabActive.store_id,
    }]);

    // Log and set for all products
    tableData.forEach(product => {
      let valueparse = JSON.parse(selectedField.value)
      const tempKey = `${valueparse.attribute_key}_${l + 1}`;

      const newEntry = {
        ...newVal,
        prod_id: product.prod_id,
        store: product.store,
        store_id: product.store_id,
        name: tempKey,
        counter: l + 1,
        id: '',
        key: '',
        new_val: '',
        value: '',
        source: 'new'
      };

      setSavedData(prevSaved => {
        const alreadyExists = prevSaved.find(item =>
          item.prod_id === newEntry.prod_id &&
          item.store_id === newEntry.store_id &&
          item.name === newEntry.name &&
          item.source === 'new' &&
          !item.removed
        );

        if (alreadyExists) {
          return prevSaved; // don't add duplicate
        }

        return [...prevSaved, newEntry];
      });
    });
  };


  const handleRemoveValue = (value, index) => {
    if (value.id) {
      // For existing values (with id), just mark as removed (undo-able)
      setSavedData(prevSaved => {
        const existing = prevSaved.find(item => item.id === value.id);
        if (existing) {
          return prevSaved.map(item =>
            item.id === value.id ? { ...item, removed: true } : item
          );
        } else {
          return [...prevSaved, { ...value, removed: true }];
        }
      });
      setData(prev =>
        prev.map((item, i) =>
          i === index ? { ...item, removed: true } : item
        )
      );
    } else {
      // For new values (no id), permanently remove
      setSavedData(prevSaved => prevSaved.filter(item => {
        return !(
          item.prod_id === value.prod_id &&
          item.store_id === value.store_id &&
          item.name === value.name &&
          item.source === value.source
        );
      }));
      setData(prev => prev.filter((item, i) => i !== index));
    }
  };

  const handleUndoValue = (index) => {
    const nonRemovedCount = data.filter(item => !item.removed).length;
    if (nonRemovedCount >= max_size) {
      setUndoErrorIndex(index);
      return;
    }

    setData(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, removed: false } : item
      )
    );
    setUndoErrorIndex(null);
  };
  const handleValuesChange = async (newValues, index, value_data) => {

    setData(prevData => {
      const updated = [...prevData];
      updated[index] = {
        ...updated[index],
        selected_values: newValues.map(val => ({ label: val, value: val }))
      };
      return updated;
    });

    // Update savedData also
    setSavedData(prevSaved => {
      const currentItem = data[index];
      const tempKey = currentItem.tempKey || `${currentItem.attribute_key}_${index + 1}`;
      const newEntry = {
        ...currentItem,
        selected_values: newValues.map(val => ({ label: val, value: val })),
        value: newValues.join(','),
        tempKey,
      };

      const existingIndex = prevSaved.findIndex(item => item.tempKey === tempKey);
      if (existingIndex !== -1) {
        const updatedSaved = [...prevSaved];
        updatedSaved[existingIndex] = newEntry;
        return updatedSaved;
      }

      return [...prevSaved, newEntry];
    });

    for (let i = 0; i < tableData.length; i++) {
      const element = tableData[i];

      const filteredData = await element.custom_fields.find(item => item.name == data[0].name)

      if (filteredData && element.prod_id != value_data.prod_id) {
        await setSavedData(prevSaved => {
          let existing = prevSaved.find(item => item.id == filteredData.id) || null;

          if (existing) {
            return prevSaved.map(item =>
              item.id == filteredData.id ? {
                ...item, selected_values: newValues.map(val => ({ label: val, value: val })),
                value: newValues.join(',')
              } : item
            );
          } else {
            const jsonobj = {
              val: filteredData.value,
              key: filteredData.id,
              id: filteredData.id,
              name: filteredData.name,
              store: value_data.store,
              store_id: value_data.store_id,
              prod_id: element.prod_id,
              new_val: newValues.join(','),
              removed: false,
              source: "new",
            }
            return [...prevSaved, {
              ...jsonobj, selected_values: newValues.map(val => ({ label: val, value: val })),
              value: newValues.join(',')
            }];
          }
        });
      }

    }
  };
  return (
    <div className='List'>
      {data.map((value, valIndex) => {

        // Skip rendering if new value is removed
        if (value.removed && value.source === 'new') return null;

        return (
          <div className='ListRow' key={valIndex}>
            <div className='ListCol'>
              <span className='ValueLabel' style={value.removed ? { textDecoration: 'line-through' } : {}}>
                Current Value {valIndex + 1}
              </span>
              <p style={value.removed ? { textDecoration: 'line-through', color: 'gray' } : {}}>
                {value.val}
              </p>
            </div>
            <div className='ListCol'>
              {value.attribute_element_type != 'dropdown' && (
                <Form.Item
                  className="abc"
                  key={valIndex}
                  label={
                    <span style={value.removed ? { textDecoration: 'line-through', color: 'gray' } : {}}>
                      New Value {valIndex + 1}&nbsp;
                      {/* <QuestionCircleOutlined
                      style={{
                        color: "rgba(0, 0, 0, 0.45)",
                        cursor: "pointer",
                      }}
                      title="This is the Attribute Value."
                    /> */}
                    </span>
                  }
                  style={{ marginBottom: 0 }}
                >
                  <Flex
                    style={{
                      display: "flex",
                      paddingBottom: "20px",
                      width: "100%",
                      gap: "8px"
                    }}
                    align="start"
                  >
                    <div style={{ width: "100%", display: 'flex', alignItems: 'center', gap: 8 }}>
                      {!value.removed ? (
                        <Input.TextArea
                          placeholder='Please Type'
                          value={value.new_val || ''} // Controlled 
                          onChange={async (e) => {
                            setIsAction(true);

                            const newValue = e.target.value;
                            let valueparse = JSON.parse(selectedField.value)
                            const tempKey = `${valueparse.attribute_key}_${valIndex + 1}`;//value.id ? null :                              
                            setSavedData(prevSaved => {

                              // First check by id (for existing)
                              const existingById = value.id
                                ? prevSaved.find(item => item.id === value.id)
                                : null;

                              if (existingById) {
                                return prevSaved.map(item =>
                                  item.id === value.id
                                    ? { ...item, value: newValue, counter: valIndex + 1, name: tempKey }
                                    : item
                                );
                              }

                              // Then check by tempKey (for new)
                              const existingByTemp = prevSaved.find(item => item.tempKey === tempKey);
                              const newEntry = {
                                ...value,
                                value: newValue,
                                counter: valIndex + 1,
                                name: tempKey,
                                tempKey // Add tempKey so we can track it next time
                              };

                              if (existingByTemp) {
                                return prevSaved.map(item =>
                                  item.tempKey === tempKey ? newEntry : item
                                );
                              }

                              // If not found at all, add it
                              return [...prevSaved, newEntry];
                            });
                            for (let i = 0; i < tableData.length; i++) {
                              const element = tableData[i];

                              const filteredData = await element.custom_fields.find(item => item.name == tempKey)

                              if (filteredData && element.prod_id != value.prod_id) {
                                await setSavedData(prevSaved => {
                                  let existing = prevSaved.find(item => item.id == filteredData.id) || null;

                                  if (existing) {
                                    return prevSaved.map(item =>
                                      item.id == filteredData.id ? { ...item, value: newValue, counter: valIndex + 1 } : item
                                    );
                                  } else {
                                    const jsonobj = {
                                      val: filteredData.value,
                                      key: filteredData.id,
                                      id: filteredData.id,
                                      name: filteredData.name,
                                      store: value.store,
                                      store_id: value.store_id,
                                      prod_id: element.prod_id,
                                      new_val: newValue,
                                      removed: false,
                                      source: "new",
                                    }
                                    return [...prevSaved, { ...jsonobj, value: newValue, counter: valIndex + 1 }];
                                  }
                                });
                              }
                              else if (!filteredData && element.prod_id != value.prod_id) {

                                setSavedData(prevSaved => {
                                  const existing = prevSaved.find(item => item.prod_id == element.prod_id && item.store_id == element.store_id && item.name == tempKey);

                                  if (existing) {
                                    return prevSaved.map(item =>
                                      item.prod_id == element.prod_id && item.store_id == element.store_id && item.name == tempKey ? { ...item, value: newValue, counter: valIndex + 1 } : item
                                    );
                                  } else {
                                    const jsonobj = {
                                      val: "",
                                      key: "",
                                      id: "",
                                      name: tempKey,
                                      store: element.store,
                                      store_id: element.store_id,
                                      prod_id: element.prod_id,
                                      new_val: newValue,
                                      value: newValue,
                                      removed: false,
                                      source: "new",
                                    }
                                    return [...prevSaved, { ...jsonobj, value: newValue, counter: valIndex + 1 }];
                                  }
                                });
                              }
                            }
                            setData(prevData =>
                              prevData.map((item, i) =>
                                i === valIndex ? { ...item, new_val: newValue, counter: valIndex + 1 } : item
                              )
                            );



                          }}


                          maxLength={250}
                          style={{ width: "100%" }}
                          showCount={{
                            formatter: ({ count, maxLength }) =>
                              `${count}/${maxLength}`,
                          }}
                        />

                      ) : (
                        <>
                          <Button
                            icon={<UndoOutlined />}
                            onClick={() => handleUndoValue(valIndex)}
                          >
                            Undo
                          </Button>
                          <Tag color="red">Removed</Tag>
                          {undoErrorIndex === valIndex && (
                            <p style={{ color: 'red', margin: 0 }}>
                              Please remove a value before undoing.
                            </p>
                          )}
                        </>
                      )}
                    </div>

                    {!value.removed && (
                      <Button
                        type="text"
                        danger
                        icon={<MinusOutlined />}
                        style={{ width: 32, padding: 0 }}
                        className='RemoveAttr'
                        onClick={() => handleRemoveValue(value, valIndex)}
                      />
                    )}
                  </Flex>
                </Form.Item>
              )}
              {value.attribute_element_type == 'dropdown' && (
                <Form.Item
                  className="abc"
                  key={valIndex}
                  label={
                    <span style={value.removed ? { textDecoration: 'line-through', color: 'gray' } : {}}>
                      New Value {valIndex + 1}&nbsp;
                      {/* <QuestionCircleOutlined
                      style={{
                        color: "rgba(0, 0, 0, 0.45)",
                        cursor: "pointer",
                      }}
                      title="This is the Attribute Value."
                    /> */}
                    </span>
                  }
                  style={{ marginBottom: 0 }}
                >

                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    allowClear
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select Values"
                    defaultValue={value.selected_values || []}
                    onChange={e => handleValuesChange(e, valIndex, value)}
                    options={dropdownValues}
                  />
                </Form.Item>
              )}
            </div>
          </div>
        );
      })}
      {attribute_element_type != "dropdown" && <div className="btnBox">
        <Button
          icon={<PlusOutlined />}
          onClick={(e) => handleAddValue(data.length)}
          disabled={nonRemovedCount >= max_size}
        >
          Add a value
        </Button>
      </div>}
    </div>
  );
};

export default ApplyAllAttributeList;
